import { render, staticRenderFns } from "./DSMB-SMCCoordinationReport.vue?vue&type=template&id=0ae7ece6&"
import script from "./DSMB-SMCCoordinationReport.vue?vue&type=script&lang=js&"
export * from "./DSMB-SMCCoordinationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports